/*
  persistence.ts

  This file contains functions for saving and loading charts configuration from localStorage.
*/
import {v4 as uuidv4} from 'uuid';

import {InternalChartConfig} from './types';

export const LOCAL_STORAGE_KEY_PREFIX = 'callsChartsConfig';

function getContextualStorageKey(entity: string, project: string) {
  return `${LOCAL_STORAGE_KEY_PREFIX}_${entity}_${project}`;
}

function getDefaultChartsConfig() {
  return {
    charts: [
      {
        id: uuidv4(),
        x_axis: 'started_at',
        y_axis: 'cost',
        plot_type: 'bar',
        bin_count: 20,
        aggregation: 'sum',
      },
      {
        id: uuidv4(),
        x_axis: 'started_at',
        y_axis: 'latency',
        plot_type: 'line',
        bin_count: 20,
        aggregation: 'p95',
      },
      {
        id: uuidv4(),
        x_axis: 'prompt_tokens',
        y_axis: 'completion_tokens',
        plot_type: 'scatter',
      },
    ],
    openDrawerChartId: null,
  };
}

export async function loadChartsConfig(
  entity: string,
  project: string
): Promise<InternalChartConfig[]> {
  try {
    const storageKey = getContextualStorageKey(entity, project);
    const data = await new Promise<string | null>(resolve => {
      resolve(localStorage.getItem(storageKey));
    });
    if (!data) return getDefaultChartsConfig().charts as InternalChartConfig[];
    return JSON.parse(data).charts as InternalChartConfig[];
  } catch (e) {
    return getDefaultChartsConfig().charts as InternalChartConfig[];
  }
}

export async function saveChartsConfig(
  config: any,
  entity: string,
  project: string
): Promise<void> {
  try {
    const storageKey = getContextualStorageKey(entity, project);
    await new Promise<void>(resolve => {
      localStorage.setItem(storageKey, JSON.stringify({charts: config}));
      resolve();
    });
  } catch (e) {
    // ignore
  }
}
